import React, { useState } from "react";
import { Space, Spin, Table, Tooltip } from "antd";
import { TbRestore } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import dayjs from "dayjs";
import { capitalizeFirstLetter ,capitalizeEachWord} from "../Common/Captilization";
import BinRestore from "./BinRestore";
import ModalPopup from "../Common/Modal/Modal";
import BinDelete from "./BinDelete";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

export default function UserManagement({ selectedTab }) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const crud=sessionStorage.getItem("crud_permission")
  const [tbsId, setTbsId] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [restoreModalOpen, SetRestoreModalOpen] = useState(false);
  const [rowName, SetRowName] = useState();
  const [sortOrderName, setSortName] = useState(null);
   const [sortOrderEmail, setSortEmail] = useState(null);
   const [sortedData, setSortedData] = useState();
   const [sortOrderMobile, setSortMobile] = useState(null);
   const [sortOrderUserDate, setSortOrderUserDate] = useState(null);
   const getBin = useSelector((state) => state.crm.bin_data);
     const [activePage, setActivePage] = useState(1);
     const itemsPerPage = selectedTab === 3 ? 5 : selectedTab === 4 ? 5 : 10;
   
     const indexOfLastItem = activePage * itemsPerPage;
     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
     const currentItems = sortedData?.length > 0
      ? sortedData.slice(indexOfFirstItem, indexOfLastItem): getBin.slice(indexOfFirstItem, indexOfLastItem)
     // Handle page change
     const handlePageChange = (pageNumber) => {
       setActivePage(pageNumber);
     };
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    SetRestoreModalOpen(false);
  };
  const handleNameSort = () => {
  // Always sort the full dataset
  let sorted = [...getBin];

  // Single function to extract the correct name based on tab
  const getName = (item) => {
    if (selectedTab === 5) {
      return item.deleted_data?.operator?.company_name || "";
    }
    if (selectedTab === 7) {
      return item.deleted_data?.clientCompanyDetails?.company_name || "";
    }
    if (selectedTab === 9) {
      return item.deleted_data?.partnerDetails?.partner_first_name || "";
    }
    if (selectedTab === 6 || selectedTab === 8) {
      return item.deleted_data?.empPersonal?.name || "";
    }
    return "";
  };

  // Toggle sort state
  if (sortOrderName === "ascend") {
    sorted.sort((a, b) => getName(b).localeCompare(getName(a)));
    setSortName("descend");
  } else if (sortOrderName === "descend") {
    sorted = [...getBin]; // Reset to original
    setSortName(null);
  } else {
    sorted.sort((a, b) => getName(a).localeCompare(getName(b)));
    setSortName("ascend");
  }

  setSortedData(sorted);
};

   const handleEmailSort=()=>{
    let sorted =[...getBin];
    if(sortOrderEmail ==="ascend"){
      sorted.sort((a,b)=>
      {
        if (selectedTab === 5) {
          const emailA=a.deleted_data?.operator?.emailid||"";
          const emailB=b.deleted_data?.operator?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 7) {
      const emailA=a.deleted_data?.clientCompanyDetails?.emailid||"";
          const emailB=b.deleted_data?.clientCompanyDetails?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 9) {
       const emailA=a.deleted_data?.partnerDetails?.emailid||"";
          const emailB=b.deleted_data?.partnerDetails?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 8 || selectedTab === 6) {
     const emailA=a.deleted_data?.empPersonal?.emailid||"";
          const emailB=b.deleted_data?.empPersonal?.emailid||"";
     return  emailB.localeCompare(emailA)
        }

      }
      )
      setSortEmail("descend")
    }else if(sortOrderEmail === "descend"){
      sorted=[...getBin];
      setSortEmail(null)
    }else{
      sorted.sort((a,b)=> 
      {
        if (selectedTab === 5) {
     const emailA=a.deleted_data?.operator?.emailid||"";
          const emailB=b.deleted_data?.operator?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 7) {
      const emailA=a.deleted_data?.clientCompanyDetails?.emailid||"";
          const emailB=b.deleted_data?.clientCompanyDetails?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 9) {
       const emailA=a.deleted_data?.partnerDetails?.emailid||"";
          const emailB=b.deleted_data?.partnerDetails?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 8 || selectedTab === 6) {
     const emailA=a.deleted_data?.empPersonal?.emailid||"";
          const emailB=b.deleted_data?.empPersonal?.emailid||"";
     return  emailA.localeCompare(emailB)
        }

      })
      setSortEmail("ascend")
    }
    setSortedData(sorted)
  }
  const handleUserDateSort = () => {
    let sorted = [...getBin]
    if (sortOrderUserDate === "ascend") {
      sorted.sort(
        (a, b) =>
          dayjs(b.deleted_date).valueOf() - dayjs(a.deleted_date).valueOf()
      );
      setSortOrderUserDate("descend");
    } else if (sortOrderUserDate === "descend") {
      sorted = [...getBin]
      setSortOrderUserDate(null);
    } else {
      sorted.sort(
        (a, b) =>
          dayjs(a.deleted_date).valueOf() - dayjs(b.deleted_date).valueOf()
      );
      setSortOrderUserDate("ascend");
    }
    setSortedData(sorted);
  };

  
   const handleMobileSort=()=>{
    let sorted =[...getBin];
    if(sortOrderMobile ==="ascend"){
      sorted.sort((a,b)=>
      {
        if (selectedTab === 5) {
          const emailA=a.deleted_data?.operator?.phone||"";
          const emailB=b.deleted_data?.operator?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 7) {
      const emailA=a.deleted_data?.clientCompanyDetails?.emailid||"";
          const emailB=b.deleted_data?.clientCompanyDetails?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 9) {
       const emailA=a.deleted_data?.partnerDetails?.emailid||"";
          const emailB=b.deleted_data?.partnerDetails?.emailid||"";
     return  emailB.localeCompare(emailA)
        } else if (selectedTab === 8 || selectedTab === 6) {
     const emailA=a.deleted_data?.empPersonal?.emailid||"";
          const emailB=b.deleted_data?.empPersonal?.emailid||"";
     return  emailB.localeCompare(emailA)
        }

      }
      )
      setSortMobile("descend")
    }else if(sortOrderMobile === "descend"){
      sorted=[...getBin];
      setSortMobile(null)
    }else{
      sorted.sort((a,b)=> 
      {
        if (selectedTab === 5) {
     const emailA=a.deleted_data?.operator?.emailid||"";
          const emailB=b.deleted_data?.operator?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 7) {
      const emailA=a.deleted_data?.clientCompanyDetails?.emailid||"";
          const emailB=b.deleted_data?.clientCompanyDetails?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 9) {
       const emailA=a.deleted_data?.partnerDetails?.emailid||"";
          const emailB=b.deleted_data?.partnerDetails?.emailid||"";
     return  emailA.localeCompare(emailB)
        } else if (selectedTab === 8 || selectedTab === 6) {
     const emailA=a.deleted_data?.empPersonal?.emailid||"";
          const emailB=b.deleted_data?.empPersonal?.emailid||"";
     return  emailA.localeCompare(emailB)
        }

      })
      setSortMobile("ascend")
    }
    setSortedData(sorted)
  }
  console.log(selectedTab, "namenamenamename");

  const columns = [
    {
      title: (
        <div className="flex font-bold justify-center text-[1.1vw]">S.No</div>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const pageNo = (activePage - 1) * itemsPerPage + index + 1
        return (
          <div className="text-[#1F4B7F] flex pl-[1vw] text-[1vw] ">
            <h1 className="pl-[1vw]">{pageNo}</h1>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex justify-center  items-center font-bold text-[1.1vw]">
          Photo
        </div>
      ),
      align: "center",
      render: (row) => {
        const image = `${apiImgUrl}${selectedTab === 5
          ? row?.deleted_data?.operator?.profileimg
          : selectedTab === 7
            ? row?.deleted_data?.clientCompanyDetails?.company_logo
            : selectedTab === 9
              ? row?.deleted_data?.partnerDetails?.profile_img
              : selectedTab === 8
                ? row?.deleted_data?.empPersonal?.profile_img
                : selectedTab === 6
                  ? row?.deleted_data?.empPersonal?.profile_img
                  : ""
          }`;
        console.log(row?.deleted_data?.operator?.profileimg, "imageimage");
        return (
          <div className="flex justify-center  items-center">
            <img
              src={`${apiImgUrl}${selectedTab === 5
                ? row?.deleted_data?.operator?.profileimg
                : selectedTab === 7
                  ? row?.deleted_data?.clientCompanyDetails?.company_logo
                  : selectedTab === 9
                    ? row?.deleted_data?.partnerDetails?.profile_img
                    : selectedTab === 8
                      ? row?.deleted_data?.empPersonal?.profile_img
                      : selectedTab === 6
                        ? row?.deleted_data?.empPersonal?.profile_img
                        : ""
                }`}
              alt="Photo"
              className="w-[2.15vw] h-[2.15vw] object-cover rounded-[0.2vw]"
            />
          </div>
        );
      },
      width: "5vw",
    },
    {
      title: (
        <div className="flex items-center justify-center  font-bold text-[1.1vw]">
          {" "}
          Name
          <button onClick={handleNameSort} className="">
                      {sortOrderName === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortOrderName === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortOrderName === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ), // dataIndex: "name",
      key: "name",
      // sorter: (a, b) => {
      //   // Get the respective names for comparison
      //   const nameA =
      //     selectedTab === 5
      //       ? (a.deleted_data?.operator?.company_name || "").toUpperCase()
      //       : selectedTab === 7
      //         ? (a.deleted_data?.clientCompanyDetails?.company_name || "")
      //         : selectedTab === 9
      //           ? (a.deleted_data?.partnerDetails?.partner_first_name || "")
      //           : selectedTab === 8 || selectedTab === 6
      //             ? (a.deleted_data?.empPersonal?.emp_first_name || "")
      //             : "";
      //   const nameB =
      //     selectedTab === 5
      //       ? (b.deleted_data?.operator?.company_name || "").toUpperCase()
      //       : selectedTab === 7
      //         ? (b.deleted_data?.clientCompanyDetails?.company_name || "")
      //         : selectedTab === 9
      //           ? (b.deleted_data?.partnerDetails?.partner_first_name || "")
      //           : selectedTab === 8 || selectedTab === 6
      //             ? (b.deleted_data?.empPersonal?.emp_first_name || "")
      //             : "";

      //   // Sort using localeCompare (case-insensitive)
      //   return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
      // },

      width: "13vw",
      render: (row) => (
        // <div className="flex pl-[1vw] items-center">
        //   <p className="text-[1vw] text-[#1F4B7F] font-semibold ">{`${selectedTab === 5
        //       ? row?.deleted_data?.operator?.company_name
        //       : selectedTab === 7
        //         ? row?.deleted_data?.clientCompanyDetails?.company_name
        //         : selectedTab === 9
        //           ? row?.deleted_data?.partnerDetails?.partner_first_name
        //           : selectedTab === 8
        //             ? row.deleted_data?.empPersonal?.emp_first_name
        //             : selectedTab === 6
        //               ? row.deleted_data?.empPersonal?.emp_first_name
        //               : ""
        //     }`}</p>
        //   <p className="text-[1.1vw] text-[#1F4B7F] pl-[.4vw] font-semibold ">{`${
        //     // selectedTab === 5
        //     //   ? row?.deleted_data?.partnerDetails?.partner_first_name 
        //     selectedTab === 8
        //       ? row.deleted_data?.empPersonal?.emp_last_name
        //       : selectedTab === 6
        //         ? row.deleted_data?.empPersonal?.emp_last_name
        //         : ""
        //     }`}</p>
        // </div>
        <div className="flex pl-[1vw] items-center">
          <p className="text-[1vw] text-[#1F4B7F] font-bold">
            {selectedTab === 5 ? (
              row?.deleted_data?.operator?.company_name?.length > 25 ? (
                <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.operator?.company_name}>
                  <span>
                    {`${row?.deleted_data?.operator?.company_name?.charAt(0) === row?.deleted_data?.operator?.company_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.operator?.company_name.slice(0, 25))
                      : row?.deleted_data?.operator?.company_name.slice(0, 25)}...`}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  {row?.deleted_data?.operator?.company_name?.charAt(0) === row?.deleted_data?.operator?.company_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.operator?.company_name)
                    : row?.deleted_data?.operator?.company_name}
                </span>

              )
            ) : selectedTab === 7 ? (
              row?.deleted_data?.clientCompanyDetails?.company_name?.length > 25 ? (
                <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.clientCompanyDetails?.company_name}>
                  <span>
                    {`${row?.deleted_data?.clientCompanyDetails?.company_name?.charAt(0) === row?.deleted_data?.clientCompanyDetails?.company_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.clientCompanyDetails?.company_name.slice(0, 25))
                      : row?.deleted_data?.clientCompanyDetails?.company_name.slice(0, 25)}...`}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  {row?.deleted_data?.clientCompanyDetails?.company_name?.charAt(0) === row?.deleted_data?.clientCompanyDetails?.company_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.clientCompanyDetails?.company_name)
                    : row?.deleted_data?.clientCompanyDetails?.company_name}
                </span>
              )
            ) : selectedTab === 9 ? (
              row?.deleted_data?.partnerDetails?.partner_first_name?.length > 25 ? (
                <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.partnerDetails?.partner_first_name}>
                  <span>
                    {`${row?.deleted_data?.partnerDetails?.partner_first_name?.charAt(0) === row?.deleted_data?.partnerDetails?.partner_first_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.partnerDetails?.partner_first_name.slice(0, 25))
                      : row?.deleted_data?.partnerDetails?.partner_first_name.slice(0, 25)}...`}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  {row?.deleted_data?.partnerDetails?.partner_first_name?.charAt(0) === row?.deleted_data?.partnerDetails?.partner_first_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.partnerDetails?.partner_first_name)
                    : row?.deleted_data?.partnerDetails?.partner_first_name}
                </span>

              )
            ) : selectedTab === 8 ? (
              row?.deleted_data?.empPersonal?.emp_first_name?.length > 25 ? (
                <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.emp_first_name}>
                  <span>
                    {`${row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0) === row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.empPersonal?.emp_first_name.slice(0, 25))
                      : row?.deleted_data?.empPersonal?.emp_first_name.slice(0, 25)}...`}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  {row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0) === row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.empPersonal?.emp_first_name)
                    : row?.deleted_data?.empPersonal?.emp_first_name}
                </span>
              )
            ) : selectedTab === 6 ? (
              row?.deleted_data?.empPersonal?.emp_first_name?.length > 25 ? (
                <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.emp_first_name}>
                  <span>
                    {`${row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0) === row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.empPersonal?.emp_first_name.slice(0, 25))
                      : row?.deleted_data?.empPersonal?.emp_first_name.slice(0, 25)}...`}
                  </span>
                </Tooltip>
              ) : (
                <span>
                  {row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0) === row?.deleted_data?.empPersonal?.emp_first_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.empPersonal?.emp_first_name)
                    : row?.deleted_data?.empPersonal?.emp_first_name}
                </span>
              )
            ) : (
              ""
            )}
          </p>
          {/* <p className="text-[1.1vw] text-[#1F4B7F] pl-[.4vw] font-semibold">
    {selectedTab === 8 ? (
      row?.deleted_data?.empPersonal?.emp_last_name?.length > 25 ? (
        <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.emp_last_name}>
          <span>{`${row?.deleted_data?.empPersonal?.emp_last_name.slice(0, 25)}...`}</span>
        </Tooltip>
      ) : (
        <span>{row?.deleted_data?.empPersonal?.emp_last_name}</span>
      )
    ) : selectedTab === 6 ? (
      row?.deleted_data?.empPersonal?.emp_last_name?.length > 25 ? (
        <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.emp_last_name}>
          <span>{`${row?.deleted_data?.empPersonal?.emp_last_name.slice(0, 25)}...`}</span>
        </Tooltip>
      ) : (
        <span>{row?.deleted_data?.empPersonal?.emp_last_name}</span>
      )
    ) : (
      ""
    )}
  </p> */}
        </div>

      ),
    },

    {
      title: (
        <div className="flex items-center justify-center  font-bold text-[1.1vw]">
          Mobile
                    <button onClick={handleMobileSort} className="">
                      {sortOrderMobile === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortOrderMobile === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortOrderMobile === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      key: "mobile",
      ellipsis: true,
      width: "10vw",
      render: (text, row) => {
        return (
          <div className="flex items-center justify-center text-[#1F4B7F] ">
            <p className="text-[1vw]">
              {selectedTab === 5
                ? row?.deleted_data?.operator?.phone
                : selectedTab === 7
                  ? row?.deleted_data?.clientCompanyDetails?.phone
                  : selectedTab === 9
                    ? row?.deleted_data?.partnerDetails?.phone
                    : selectedTab === 8
                      ? row.deleted_data?.empPersonal?.phone?.replace(/\D/g, "")
                      : selectedTab === 6
                        ? row.deleted_data?.empPersonal?.phone?.replace(/\D/g, "")
                        : ""}
            </p>
          </div>
        );
      },
    },

    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.1vw]">
          Email
          <button onClick={handleEmailSort} className="">
                      {sortOrderEmail === "ascend" ? (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      ) : sortOrderEmail === "descend" ? (
                        <Tooltip
                          placement="top"
                          title="Descending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedDown />
                        </Tooltip>
                      ) : sortOrderEmail === null ? (
                        <Tooltip
                          placement="top"
                          title="Unsorted"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowUnsorted />
                        </Tooltip>
                      ) : (
                        <Tooltip
                          placement="top"
                          title="Ascending"
                          className="cursor-pointer"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <TiArrowSortedUp />
                        </Tooltip>
                      )}
                    </button>
        </div>
      ),
      key: "email",
      ellipsis: true,
      width: "14vw",
      render: (row) => {
        return (
          // <div className="flex items-center pl-[1vw] text-[#1F4B7F] ">
          //   <p className="text-[1vw]">
          //     {selectedTab === 5
          //       ? row.deleted_data?.operator?.emailid
          //       : selectedTab === 7
          //         ? row?.deleted_data?.clientCompanyDetails?.emailid
          //         : selectedTab === 9
          //           ? row?.deleted_data?.partnerDetails?.emailid
          //           : selectedTab === 8
          //             ? row?.deleted_data?.empPersonal?.email_id
          //             : selectedTab === 6
          //               ? row?.deleted_data?.empPersonal?.email_id
          //               : ""}
          //   </p>
          // </div>
          <div className="flex items-center pl-[1.5vw] text-[#1F4B7F]">
            <p className="text-[1vw]">
              {selectedTab === 5 ? (
                row.deleted_data?.operator?.emailid?.length > 25 ? (
                  <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row.deleted_data?.operator?.emailid}>
                    <span>{`${row.deleted_data?.operator?.emailid.slice(0, 25)}...`}</span>
                  </Tooltip>
                ) : (
                  <span>{row.deleted_data?.operator?.emailid}</span>
                )
              ) : selectedTab === 7 ? (
                row?.deleted_data?.clientCompanyDetails?.emailid?.length > 25 ? (
                  <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.clientCompanyDetails?.emailid}>
                    <span>{`${row?.deleted_data?.clientCompanyDetails?.emailid.slice(0, 25)}...`}</span>
                  </Tooltip>
                ) : (
                  <span>{row?.deleted_data?.clientCompanyDetails?.emailid}</span>
                )
              ) : selectedTab === 9 ? (
                row?.deleted_data?.partnerDetails?.emailid?.length > 25 ? (
                  <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.partnerDetails?.emailid}>
                    <span>{`${row?.deleted_data?.partnerDetails?.emailid.slice(0, 25)}...`}</span>
                  </Tooltip>
                ) : (
                  <span>{row?.deleted_data?.partnerDetails?.emailid}</span>
                )
              ) : selectedTab === 8 ? (
                row?.deleted_data?.empPersonal?.email_id?.length > 25 ? (
                  <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.email_id}>
                    <span>{`${row?.deleted_data?.empPersonal?.email_id.slice(0, 25)}...`}</span>
                  </Tooltip>
                ) : (
                  <span>{row?.deleted_data?.empPersonal?.email_id}</span>
                )
              ) : selectedTab === 6 ? (
                row?.deleted_data?.empPersonal?.email_id?.length > 25 ? (
                  <Tooltip color="white" overlayInnerStyle={{ color: "#1F4B7F" }} title={row?.deleted_data?.empPersonal?.email_id}>
                    <span>{`${row?.deleted_data?.empPersonal?.email_id.slice(0, 25)}...`}</span>
                  </Tooltip>
                ) : (
                  <span>{row?.deleted_data?.empPersonal?.email_id}</span>
                )
              ) : (
                ""
              )}
            </p>
          </div>

        );
      },
    },

    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.1vw]">
          Deleted Date
          <button onClick={handleUserDateSort} className="">
                                          {sortOrderUserDate === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderUserDate === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderUserDate === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </div>
      ),
      key: "created_date",
     
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex justify-center items-center text-[#1F4B7F] ">
            <p className="text-[1vw]">
              {dayjs(row.deleted_date).format("DD MMM, YY")}
            </p>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex items-center justify-center font-bold text-[1.2vw]">
          Status
        </div>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex items-center justify-center">
            <button
              className={`cursor-not-allowed ${(() => {
                if (selectedTab === 5) {
                  return row.deleted_data?.operator?.user_status_id == 0
                    ? "bg-[#646262]"
                    : row.deleted_data?.operator?.user_status_id == 1
                      ? "bg-[#FF9900]"
                      : row.deleted_data?.operator?.user_status_id == 2
                        ? "bg-[#34AE2B]"
                        : row.deleted_data?.operator?.user_status_id == 3
                          ? "bg-[#FD3434]"
                          : "bg-[#2A99FF] cursor-not-allowed";
                } else if (selectedTab === 7) {
                  return row.deleted_data?.clientCompanyDetails?.status_id == 0
                    ? "bg-[#646262]"
                    : row.deleted_data?.clientCompanyDetails?.status_id == 1
                      ? "bg-[#34AE2B]"
                      : row.deleted_data?.clientCompanyDetails?.status_id == 2
                        ? "bg-[#FD3434]"
                        : "bg-[#2A99FF] cursor-not-allowed";
                } else if (selectedTab === 9) {
                  return row.deleted_data?.partnerDetails?.partner_status_id ==
                    0
                    ? "bg-[#646262]"
                    : row.deleted_data?.partnerDetails?.partner_status_id == 1
                      ? "bg-[#FF9900]"
                      : row.deleted_data?.partnerDetails?.partner_status_id == 2
                        ? "bg-[#34AE2B]"
                        : row.deleted_data?.partnerDetails?.partner_status_id == 3
                          ? "bg-[#FD3434]"
                          : "bg-[#2A99FF]  cursor-not-allowed";
                } else if (selectedTab === 8) {
                  return row.deleted_data?.empPersonal?.emp_status_id == 0
                    ? "bg-[#646262]"
                    : row.deleted_data?.empPersonal?.emp_status_id == 1
                      ? "bg-[#34AE2B]"
                      : row.deleted_data?.empPersonal?.emp_status_id == 2
                        ? "bg-[#FD3434]"
                        : "bg-[#2A99FF] cursor-not-allowed";
                } else if (selectedTab === 6) {
                  return row.deleted_data?.empPersonal?.emp_status_id == 0
                    ? "bg-[#646262]"
                    : row.deleted_data?.empPersonal?.emp_status_id == 1
                      ? "bg-[#34AE2B]"
                      : row.deleted_data?.empPersonal?.emp_status_id == 2
                        ? "bg-[#FD3434]"
                        : "bg-[#2A99FF] cursor-not-allowed";
                } else {
                  return "bg-[#FF9900] cursor-not-allowed";
                }
              })()} h-[1.8vw] shadow-md shadow-[black] font-extrabold text-[1vw] cursor-not-allowed text-white w-[7vw] rounded-[0.5vw]`}
            >
              {capitalizeFirstLetter(
                selectedTab === 5
                  ? row.deleted_data?.operator?.user_status
                  : selectedTab === 7
                    ? row.deleted_data?.clientCompanyDetails?.status
                    : selectedTab === 9
                      ? row.deleted_data?.partnerDetails?.partner_status
                      : selectedTab === 8
                        ? row.deleted_data?.empPersonal?.emp_status
                        : selectedTab === 6
                          ? row.deleted_data?.empPersonal?.emp_status
                          : ""
              )}
            </button>
          </div>
        );
      },
    },

    {
      title: (
        <div className="flex justify-center font-bold text-[1.1vw]">
          Actions
        </div>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex gap-[0.7vw] items-center justify-center">
            <span
              className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("delete")?"cursor-not-allowed":"cursor-pointer"}`}
              onClick={() => {
                if(!crud?.includes("view") && !crud?.includes("delete") && !crud?.includes("create")){
                SetRestoreModalOpen(true);
                setTbsId(row?.tbs_recycle_id);
                SetRowName(() => {
                  if (selectedTab === 5) {
                    return row?.deleted_data?.operator?.company_name;
                  } else if (selectedTab === 7) {
                    return row?.deleted_data?.clientCompanyDetails
                      ?.company_name;
                  } else if (selectedTab === 9) {
                    return row?.deleted_data?.partnerDetails
                      ?.partner_first_name;
                  } else if (selectedTab === 8) {
                    return row?.deleted_data?.empPersonal?.emp_first_name;
                  } else if (selectedTab === 6) {
                    return row?.deleted_data?.empPersonal?.emp_first_name;
                  }
                });
              }}}
            >
              <TbRestore size={"1.3vw"} color="#1F4B7F" />
            </span>
            <span>
              <MdDelete
                size={"1.3vw"}
                color="#1F4B7F"
                className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("update")?"cursor-not-allowed":"cursor-pointer"}`}
                onClick={() => {
                   if(!crud?.includes("view") && !crud?.includes("update") && !crud?.includes("create")){
                  setDeleteModalOpen(true);
                  setTbsId(row?.tbs_recycle_id);
                  SetRowName(() => {
                    if (selectedTab === 5) {
                      return row?.deleted_data?.operator?.company_name;
                    } else if (selectedTab === 7) {
                      return row?.deleted_data?.clientCompanyDetails
                        ?.company_name;
                    } else if (selectedTab === 9) {
                      return row?.deleted_data?.partnerDetails
                        ?.partner_first_name;
                    } else if (selectedTab === 8) {
                      return row?.deleted_data?.empPersonal?.emp_first_name;
                    } else if (selectedTab === 6) {
                      return row?.deleted_data?.empPersonal?.emp_first_name;
                    }
                  });
                }}}
              />
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>

      <div className="h-[72vh] w-full">
        <Table
          dataSource={currentItems}
          columns={columns}
          pagination={false}
          className="custom-table"
        />
      </div>
      <div>
        {getBin?.length > 10 ? (
            <div className="w-full h-[8vh] flex justify-between items-center ">
              <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw]">
                <span>Showing</span>
                <span className="font-bold">
                  {currentItems && currentItems?.length > 0 ? (
                    <div>
                      {indexOfFirstItem + 1} -{" "}
                      {indexOfFirstItem + currentItems?.length}
                    </div>
                  ) : (
                    "0"
                  )}
                </span>
                <span>from</span>
                <span className="font-bold">
                  {getBin?.length > 0 ? getBin?.length : 0}
                </span>
                <span>data</span>
              </div>
              <div>
                <ReactPaginate
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={getBin?.length}
                  pageRangeDisplayed={3}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                  prevPageText={
                    <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                  }
                  nextPageText={
                    <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                  }
                  firstPageText={
                    <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                  }
                  lastPageText={
                    <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
      </div>
      <ModalPopup
        show={deleteModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinDelete
          setDeleteModalOpen={setDeleteModalOpen}
          deleteid={tbsId}
          // title={`want to delete ( ${rowName} ) Permenantly`}
          title={
            <>
              Want to delete <span style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(rowName)}</span> permanently ?
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>

      <ModalPopup
        show={restoreModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinRestore
          SetRestoreModalOpen={SetRestoreModalOpen}
          // title={`want to restore ( ${rowName} ) `}
          title={
            <>
              Want to restore <span style={{ fontWeight: 'bold' }}>{capitalizeEachWord(rowName)} ?</span>
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>
    </>
  );
}
